// Function to add multiple products to the cart
    function addProductsToCart(items) {

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: items
        }),
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(errorData => {
            throw new Error(errorData.description || 'Failed to add products to cart.');
          });
        }
        return response.json();
      })
      .then(data => {
        console.log('Products added to cart:', data);
        // Redirect to the cart page after adding all products
        window.location.href = '/checkout';
      })
      .catch((error) => {
        console.error('Error adding products to cart:', error);
        alert(`There was an error transferring your cart: ${error.message}`);
        hideLoading(); // Hide loading spinner in case of error
      });
    }

    // Function to extract URL parameters and prepare products for cart
    function getCartParamsFromUrlAndAddToCart() {
      const urlParams = new URLSearchParams(window.location.search);
      const items = [];

      for (const [key, value] of urlParams.entries()) {
        const match = key.match(/updates\[(\d+)\]/);
        if (match) {
          const variantId = match[1]; // Extract variant ID from the key
          const quantity = parseInt(value, 10); // Get quantity and convert to integer
          if (!isNaN(quantity) && variantId) { // Validate quantity and variant ID
            items.push({
              id: variantId,
              quantity: quantity
            });
          }
        }
      }

      if (items.length > 0) {
        addProductsToCart(items);
      } else {
        console.log('No valid cart items found in URL.');
      }
    }

    // Function to remove query parameters from the URL to prevent re-processing
    function removeQueryParams() {
      if (window.history.replaceState) {
        const url = window.location.protocol + "//" + window.location.host + window.location.pathname;
        window.history.replaceState({path: url}, '', url);
      }
    }

    // Call this function on page load to process the URL and add products to the cart
    window.addEventListener('load', () => {
      getCartParamsFromUrlAndAddToCart();
      removeQueryParams(); // Remove query parameters after processing
    });


// // Function to add product to the cart using the variant ID and quantity
// function addProductToCart(variantId, quantity) {
//     fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//             id: variantId,
//             quantity: quantity
//         }),
//     })
//     .then(response => response.json())
//     .then(data => {
//         console.log('Product added to cart:', data);
//         // Redirect to the cart page after adding the product
//         window.location.href = '/cart';
//     })
//     .catch((error) => {
//         console.error('Error adding product to cart:', error);
//     });
// }

// // Function to extract URL parameters and add products to cart
// function getCartParamsFromUrlAndAddToCart() {
//     const urlParams = new URLSearchParams(window.location.search);
    
//     for (const [key, value] of urlParams.entries()) {
//         const match = key.match(/updates\[(\d+)\]/);
//         if (match) {
//             const variantId = match[1]; // Extract variant ID from the key
//             const quantity = parseInt(value, 10); // Get quantity and convert to integer
//             addProductToCart(variantId, quantity); // Add product to cart
//         }
//     }
// }

// // Call this function on page load or when needed
// getCartParamsFromUrlAndAddToCart();